export default __webpack_public_path__ + "media/images/loop4-4ef6aa52af65cb37ac818985b3938f1f.png";